import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { useWorld } from '../../contexts/WorldDataContext';
import { mapPath, nameKey } from '../../utils/worldFormat';
import { derived } from '../../utils/worldQueries';

/** Mapas mencionados en una ficha, enlazados al explorador cuando el nombre existe en maps.csv. */
export function WorldMapLinks({
  names
}: {
  names: string[];
}) {
  const world = useWorld();
  const byName = world.data ? derived(world.data).mapByName : undefined;
  return <ul className="flex flex-wrap gap-2" data-id="element-2118" data-mp="3jmu554osocp">
      {names.map(n => {
      const m = byName?.get(nameKey(n));
      return <li key={n} data-id="element-2119" data-mp="3uomy1karbflw">
            {m ? <Link to={mapPath(m.id)} className="inline-flex h-10 items-center gap-2 rounded-full border border-white/15 px-4 text-sm font-semibold text-gray-200 transition-colors duration-150 hover:border-[#D4AF37]/50 hover:text-white" data-id="element-2120" data-mp="3qpxa4xs3efo0">
                <MapPin className="h-4 w-4 text-[#D4AF37]" aria-hidden="true" data-id="element-2121" data-mp="3grq7ljyjw05j" />
                {n}
              </Link> : <span className="inline-flex h-10 items-center gap-2 rounded-full border border-white/10 px-4 text-sm text-gray-300" data-id="element-2122" data-mp="ofyvyi3mowub">
                <MapPin className="h-4 w-4 text-gray-500" aria-hidden="true" data-id="element-2123" data-mp="apvee4fp1rb7" />
                {n}
              </span>}
          </li>;
    })}
    </ul>;
}